module.exports = __webpack_public_path__ + "29df6527343af2a34ac569f2ca75cff4.svg";